import React from 'react';
import Translate from "../../../../../../../../../components/Translate";
import LoadingComponent from "../../../../../../../../../components-new/ui/LoadingComponent";
import SilverButton from "../../../../../../../../../components-new/buttons/SilverButton";
import Colors from "../../../../../../../../../utils/Colors";

/**
 * What a settings block shows while its own request is in flight, and what it
 * shows when that request failed.
 *
 * Both used to be rendered as nothing at all, which is indistinguishable from a
 * setting the company does not have - and that is how the panel came to look
 * complete while missing half of it.
 */
const AiBlockPlaceholder = ({failed, onRetry}) => {
    if (!failed) {
        return (
            <div style={{display: 'flex', justifyContent: 'flex-start', padding: '4px 0'}}>
                <LoadingComponent size={22} style={{color: Colors.silverBlueLite}} stroke="currentColor" containerStyles={{
                    width: 'auto',
                    height: 'auto',
                    justifyContent: 'flex-start'
                }}/>
            </div>
        );
    }

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'}}>
            <span style={{fontSize: '12px', lineHeight: '1.45', color: Colors.silverBlueDark}}>
                <Translate text="somethingWentWrong"/>
            </span>

            <SilverButton
                type={'button'}
                width={'120px'}
                height={'34px'}
                onClick={onRetry}
                children={<Translate text="tryAgain"/>}
            />
        </div>
    );
};

export default AiBlockPlaceholder;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/AI/AiBlockPlaceholder.jsx